import React from 'react';
import { Link } from 'react-router-dom';
import inescLogo from '../assets/images/INESCTEC_logotipo_color_rgb.png';
import eliaLogo from '../assets/images/elia-group-logo-svg.svg';
import prrLogo from '../assets/images/ate_1.png';

const linkClass = 'text-slate-500 dark:text-gray-400 hover:text-slate-700 dark:hover:text-gray-200 transition-colors';

// Two tiers: the partners (who builds, advises and funds Predico) on top, and
// a quiet meta row below with the copyright and contact on the left, and
// status plus the legal links on the right.
export default function PublicFooter() {
  return (
    <footer className="max-w-7xl 2xl:max-w-[1600px] mx-auto px-6 pt-8 pb-6 w-full relative">
      <div
        aria-hidden="true"
        className="absolute top-0 left-0 right-0 h-px bg-slate-900/15 dark:bg-gray-100/15"
        style={{ WebkitMaskImage: 'linear-gradient(to right, transparent, black 30%, black 70%, transparent)', maskImage: 'linear-gradient(to right, transparent, black 30%, black 70%, transparent)' }}
      />

      {/* Partners */}
      <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-4 text-[10px] uppercase tracking-wider text-slate-500 dark:text-gray-400">
        {/* built-by moves to the homepage fold on mobile; shown here on sm+ only */}
        <div className="hidden sm:flex items-center gap-3">
          <span className="opacity-70">Built by</span>
          <a href="https://www.inesctec.pt" target="_blank" rel="noopener noreferrer"
             className="inline-flex items-center hover:opacity-100 transition-opacity">
            {/* Logos are matched by visible height: INESC TEC's asset is
                trimmed to the mark, the Elia SVG spans swoosh to "Elia Group"
                (so its box stays taller), and the funding strip is cropped. */}
            <img src={inescLogo} alt="INESC TEC" className="h-[18px] object-contain opacity-80"/>
          </a>
        </div>
        <div className="flex items-center gap-3">
          <span className="opacity-70">R&amp;D partner</span>
          <a href="https://www.eliagroup.eu" target="_blank" rel="noopener noreferrer"
             className="inline-flex items-center hover:opacity-100 transition-opacity">
            <img src={eliaLogo} alt="Elia Group" className="h-8 object-contain opacity-80"/>
          </a>
        </div>
        <div className="flex items-center gap-3">
          <span className="opacity-70">Funded by</span>
          {/* The official strip has ~34% transparent padding above and below
              its logos: crop it to 18px of visible height instead of editing
              the file. */}
          <span className="inline-flex h-[18px] items-center overflow-hidden">
            <img src={prrLogo} alt="PRR · República Portuguesa · Financiado pela União Europeia NextGenerationEU" className="h-[57px] max-w-none object-contain opacity-70 hover:opacity-100 transition-opacity"/>
          </span>
        </div>
      </div>

      {/* Meta row; the legal links stay visible at every breakpoint */}
      <div className="mt-6 flex flex-col-reverse items-center gap-3 border-t border-slate-900/10 dark:border-gray-100/10 pt-4 text-xs text-slate-500 dark:text-gray-400 sm:flex-row sm:justify-between">
        <div className="flex items-center gap-x-3">
          {/* explicit color: a global :where(span) rule would otherwise make it gray-700 */}
          <span className="text-slate-500 dark:text-gray-400">© {new Date().getFullYear()} Predico</span>
          {/* contact moves to the homepage fold on mobile; shown here on sm+ only */}
          <span className="hidden sm:inline-block h-3 w-px bg-slate-900/15 dark:bg-gray-100/15" aria-hidden="true"/>
          <a href="mailto:predico@inesctec.pt" className={`hidden sm:inline ${linkClass}`}>predico@inesctec.pt</a>
        </div>
        <div className="flex items-center gap-x-4">
          <a href="https://status.predico.inesctec.pt/" target="_blank" rel="noopener noreferrer" className={linkClass}>
            Status
          </a>
          <nav aria-label="Legal" className="flex items-center gap-x-4">
            <Link to="/terms" className={linkClass}>Terms of Use</Link>
            <Link to="/privacy" className={linkClass}>Privacy Policy</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
